import { IconButton } from '@mui/material';
import { toggleControl } from '../../../../store/control/duck';
import store from '../../../../store';
import React from 'react';
import RewriteMessageDrawer from './drawer';
import { tracking } from '../../../../utils/tracking';
import MyToolbarButton from '../../../../utils/myToolbarButton';
import { shouldEnableChatGPT } from '../../../../utils/user';

const ChatGPTRewriteMessageButton = props => {
  return (
    <IconButton
      style={props.style}
      aria-label="GPTRewriteMessageDrawerButton"
      onClick={() => {
        // console.log('ChatGPTRewriteMessageButton onClick called');
        tracking('Click on RewriteMessage - ChatGPT');
        store.dispatch(
          toggleControl('chatGPTRewriteMessageDrawer', {
            open: true,
            message: props.message,
            client: props.client,
            type: props.type,
            onValue: props.onValue,
            closeOnValue: props.closeOnValue
          })
        );
      }}
      size="large">
      <img
        style={{
          width: '20px',
          height: '20px',
          ...props.iconStyle
        }}
        src="img/icons/ai_bg_free.svg"
      />
    </IconButton>
  );
};

export const ChatGPTRewriteMessageToolbarButton = props => {
  return (
    <MyToolbarButton
      i="img/icons/ai_bg_free.svg"
      iconStyle={{
        marginTop: '-6px'
      }}
      {...props}
      aria-label="ChatGPTRewriteMessageToolbarButton"
      onClick={() => {
        // console.log('ChatGPTRewriteMessageButton onClick called');
        tracking('Click on RewriteMessage - ChatGPT');
        store.dispatch(
          toggleControl('chatGPTRewriteMessageDrawer', {
            open: true,
            message: props.message,
            client: props.client,
            type: props.type,
            onValue: props.onValue,
            closeOnValue: props.closeOnValue
          })
        );
      }}
    />
  );
};

export const ChatGPTRewriteMessageDrawer = RewriteMessageDrawer;
export const ChatGPTRewriteMessage = props => {
  const gptEnabled = shouldEnableChatGPT({
    user: store.getState().user.userDetails,
    teamCampaignCodes: store.getState().functions.campaignCodes,
    userSubscription: store.getState().userSubscription.userSubscription
  });

  if (!gptEnabled) return <></>;

  const { buttonType, containerStyle } = props;
  return (
    <div style={containerStyle}>
      <RewriteMessageDrawer />
      {buttonType === 'toolbar' ? (
        <ChatGPTRewriteMessageToolbarButton {...props} />
      ) : (
        <ChatGPTRewriteMessageButton {...props} />
      )}
    </div>
  );
};
